import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const SanctionRevenueBreakDownApi = (data) => {
    return API.post(`${URL.GET_ALL_SANCTION_REVENUE_BREAK_DOWN_LIST}`, data.body, {
        params: data.params
    })
}

export const ClubListForSanctionRevenueBreakDownApi = (data) =>
    API.post(`${URL.GET_ALL_SANCTION_REVENUE_BREAK_DOWN_CLUB_LIST}`, data)
export const UserListByClubForSanctionRevenueBreakDownApi = (data) =>
    API.post(`${URL.GET_ALL_SANCTION_REVENUE_BREAK_DOWN_USER_LIST_BY_CLUB}`, data.body)
export const SanctionRevenueBreakDownGrandTotalApi = (data) =>
    API.get(`${URL.SANCTION_REVENUE_BREAK_DOWN_GRAND_TOTAL}`, data?.params)
